<template>
  <div class="weui-form-preview" v-if="flag === true">
    <div class="weui-form-preview__hd">
      <div class="weui-form-preview__item">
        <p>请假详情</p>
      </div>
    </div>
    <div class="weui-form-preview__bd">
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">申请人</label>
        <span class="weui-form-preview__value">{{Info.Staff_Name}}</span>
      </div>
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">请假类型</label>
        <span class="weui-form-preview__value">{{Info.Leave_Type}}</span>
      </div>
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">开始时间</label>
        <span class="weui-form-preview__value">{{Info.Date_Start}}</span>
      </div>
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">结束时间</label>
        <span class="weui-form-preview__value">{{Info.Date_End}}</span>
      </div>
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">合计</label>
        <span class="weui-form-preview__value">{{Info.Total}}</span>
      </div>
      <div class="weui-form-preview__item">
        <label class="weui-form-preview__label">事由</label>
        <span class="weui-form-preview__value">{{Info.Subject}}</span>
      </div>
      <br/>
    </div>
  </div>
  <van-empty image="error" description="无此请假详情，请在后台确认"  v-else/>
</template>

<script>
import {GetLeaveInfo} from "@/api/leave";
import store from '@/store'
import {Toast} from "vant";
import {Emas} from "@/assets/js/Emas";

export default {
  name: "LeaveInfo",
  data() {
    return {
      flag: true,
      Leave_ID: 0,
      token: '',
      Info: {}
    }
  },
  created() {
    this.Leave_ID = this.$route.query.Leave_ID
    console.log(this)
    this.token = store.getters["token"]
    this.fetchData()
    let Staff_Name = sessionStorage.getItem("Staff_Name");
    let DD_ID = sessionStorage.getItem("DD_ID");
    Emas(Staff_Name, DD_ID,"leaveInfo", "请假详情", "yywjjoa.yy.gov.cn/leaveInfo")
  },

  methods:{
    async fetchData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '正在加载',
        forbidClick: true,
      });
      const {data} = await GetLeaveInfo({Leave_ID:this.Leave_ID, token:this.token})
      Toast.clear();
      if (data.code === 200) {
        this.flag = true
        this.Info = data.data
      } else {
        this.flag = false
      }
    },
  }
}
</script>

<style scoped>
  .weui-form-preview__hd{
    text-align: center;
  }
  .weui-cell{ font-size: .9em;}

  /*项目进度CSS*/
  .weui-form-preview{
    overflow: inherit;
  }
  .weui-cell{
    top: 0;
    position: sticky;
  }
  .middle table {
    background-color: #fff;
    padding-left: 3%;
    padding-right: 3%;
    font-size: 14px;
  }
  .middle table tr th {
    font-weight: normal;
    border-bottom: 1px solid #dcdcdc;
    border-top: 1px solid #dcdcdc;
    padding-top: 3%;
    padding-bottom: 3%;
    text-align: center;
  }
  .middle table tr th:first-child {

    text-align: left;
  }
  .middle table tr td{

    text-align: center;
  }
  .middle table tr td:first-child {

    text-align: left;
  }
  .weui-cell__bd span{
    color:#5288f5 ;
  }
  article h4,
  h4 {
    top: 0;
    position: sticky;
  }
</style>